export const domain = 'https://www.citypharmacy.ca/';
